import React, { useEffect } from "react";
import { MapContainer, Popup, TileLayer, useMap } from "react-leaflet";
import CustomMarker from "./CustomMarker";
import { Marker } from "react-leaflet";
import MarkerIcon from "./../assets/open-club-location.svg"

import { cn } from "../lib/utils";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

const customIcon = L.icon({
  iconUrl: MarkerIcon,
  iconSize: [32 , 32],
  iconAnchor: [25, 0],  
});

const clubRelous = [
  13412, 12278, 13613
];

function metropolitanClubs(club) {
  return clubRelous.indexOf(club.msdsId) === -1;
}
function MapController({clubs, center}) {
  const map = useMap();

  useEffect( () => {
    if( ! map )
      return;

    if(center){
      map.setZoom(11);
      return;
    }
    if( !clubs.length )
      return;
    
    map.fitBounds( clubs.filter(metropolitanClubs).map( c => [c.lat, c.long] ))
  }, [map, clubs, center])

  return null;
}

export default function Map({club,className="", onSelect, center, clubs, onChooseClub }) {
  return (
    <MapContainer center={center} zoom={6} className={className}>
      <MapController clubs={clubs} center={center} />
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {club && (
        <CustomMarker position={[club.lat, club.long]}>
          <Popup closeButton={false} minWidth={130}>
            <div role="button" className="cursor-pointer bg-white absolute bottom-0 w-full left-0 rounded-[4px]" onClick={()=>{ onChooseClub && onChooseClub(club) }}>
              <img src={club.imgUrl} className="w-full h-auto rounded-[4px]" alt={club.name} />
              <div className="p-3">
                <h3 className="text-base font-semibold">{club.name}</h3>
                <address className="not-italic">
                  <div className="text-sm font-medium mb-1">{club.address}</div>
                  {(!!club.address2 && club.address2 !== "null") &&
                    <div className="text-sm font-medium mb-1">{club.address2}</div>
                  }
                  <div className="text-sm text-oaBackgroundText">{`${club.zip} ${club.city}`}</div>
                </address>
              </div>
            </div>
          </Popup>
        </CustomMarker>
      )}
      {
        clubs.filter( c => c.msdsId != club?.msdsId).map((c)=>{
          return (
            <Marker key={c.msdsId} position={[c.lat, c.long]} icon={customIcon} eventHandlers={{
                click: (e) => onSelect(c)
            }}/>
          )
        })
      }
    </MapContainer>
  );  
}
